import { createApiSlice } from "../../components/common/commonSlice";
import {
  CRUD_CONTRACT_CRM_TEAM,
  GET_CONTRACT_CRM_TEAM_BY_CONTRACT_ID,
  CRUD_ACCOUNT_CRM_TEAM,
  GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
  CRUD_OPPORTUNITY_CRM_TEAM,
  GET_OPPORTUNITY_CRM_TEAM_BY_OPPORTUNITY_ID,
  CRUD_CONTACT_CRM_TEAM,
  GET_CONTACT_CRM_TEAM_BY_CONTACT_ID,
  CRUD_LEAD_CRM_TEAM,
  GET_LEAD_CRM_TEAM_BY_LEAD_ID,
  CRUD_CAMPAIGN_CRM_TEAM,
  GET_CAMPAIGN_CRM_TEAM_BY_CAMPAIGN_ID,
  CRUD_INQUIRY_CRM_TEAM,
  GET_INQUIRY_CRM_TEAM_BY_INQUIRY_ID,
  CRUD_PROSPECT_CRM_TEAM,
  GET_PROSPECT_CRM_TEAM_BY_PROSPECT_ID,
  CRUD_CUSTOMER_CRM_TEAM,
  GET_CUSTOMER_CRM_TEAM_BY_CUSTOMER_ID,
  CRUD_ORDER_CRM_TEAM,
  GET_ORDER_CRM_TEAM_BY_ORDER_ID,
} from "@routes";

// Define the API config array for CRM Team CRUD per entity
const apiConfig = [
  // Contract CRM Team
  {
    name: "addContractCrmTeam",
    method: "post",
    url: CRUD_CONTRACT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getContractCrmTeam",
    method: "get",
    url: GET_CONTRACT_CRM_TEAM_BY_CONTRACT_ID,
    stateKey: "data",
  },
  {
    name: "updateContractCrmTeam",
    method: "put",
    url: CRUD_CONTRACT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteContractCrmTeam",
    method: "delete",
    url: CRUD_CONTRACT_CRM_TEAM,
    stateKey: "message",
  },

  // Customer Account CRM Team
  {
    name: "addAccountCrmTeam",
    method: "post",
    url: CRUD_ACCOUNT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getAccountCrmTeam",
    method: "get",
    url: GET_ACCOUNT_CRM_TEAM_BY_ACCOUNT_ID,
    stateKey: "data",
  },
  {
    name: "updateAccountCrmTeam",
    method: "put",
    url: CRUD_ACCOUNT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteAccountCrmTeam",
    method: "delete",
    url: CRUD_ACCOUNT_CRM_TEAM,
    stateKey: "message",
  },

  // Opportunity CRM Team
  {
    name: "addOpportunityCrmTeam",
    method: "post",
    url: CRUD_OPPORTUNITY_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getOpportunityCrmTeam",
    method: "get",
    url: GET_OPPORTUNITY_CRM_TEAM_BY_OPPORTUNITY_ID,
    stateKey: "data",
  },
  {
    name: "updateOpportunityCrmTeam",
    method: "put",
    url: CRUD_OPPORTUNITY_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteOpportunityCrmTeam",
    method: "delete",
    url: CRUD_OPPORTUNITY_CRM_TEAM,
    stateKey: "message",
  },

  // Contact CRM Team
  {
    name: "addContactCrmTeam",
    method: "post",
    url: CRUD_CONTACT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getContactCrmTeam",
    method: "get",
    url: GET_CONTACT_CRM_TEAM_BY_CONTACT_ID,
    stateKey: "data",
  },
  {
    name: "updateContactCrmTeam",
    method: "put",
    url: CRUD_CONTACT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteContactCrmTeam",
    method: "delete",
    url: CRUD_CONTACT_CRM_TEAM,
    stateKey: "message",
  },

  // Lead CRM Team
  {
    name: "addLeadCrmTeam",
    method: "post",
    url: CRUD_LEAD_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getLeadCrmTeam",
    method: "get",
    url: GET_LEAD_CRM_TEAM_BY_LEAD_ID,
    stateKey: "data",
  },
  {
    name: "updateLeadCrmTeam",
    method: "put",
    url: CRUD_LEAD_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteLeadCrmTeam",
    method: "delete",
    url: CRUD_LEAD_CRM_TEAM,
    stateKey: "message",
  },

  // Campaign CRM Team
  {
    name: "addCampaignCrmTeam",
    method: "post",
    url: CRUD_CAMPAIGN_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getCampaignCrmTeam",
    method: "get",
    url: GET_CAMPAIGN_CRM_TEAM_BY_CAMPAIGN_ID,
    stateKey: "data",
  },
  {
    name: "updateCampaignCrmTeam",
    method: "put",
    url: CRUD_CAMPAIGN_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteCampaignCrmTeam",
    method: "delete",
    url: CRUD_CAMPAIGN_CRM_TEAM,
    stateKey: "message",
  },

  // Inquiry CRM Team
  {
    name: "addInquiryCrmTeam",
    method: "post",
    url: CRUD_INQUIRY_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getInquiryCrmTeam",
    method: "get",
    url: GET_INQUIRY_CRM_TEAM_BY_INQUIRY_ID,
    stateKey: "data",
  },
  {
    name: "updateInquiryCrmTeam",
    method: "put",
    url: CRUD_INQUIRY_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteInquiryCrmTeam",
    method: "delete",
    url: CRUD_INQUIRY_CRM_TEAM,
    stateKey: "message",
  },

  // Prospect CRM Team
  {
    name: "addProspectCrmTeam",
    method: "post",
    url: CRUD_PROSPECT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getProspectCrmTeam",
    method: "get",
    url: GET_PROSPECT_CRM_TEAM_BY_PROSPECT_ID,
    stateKey: "data",
  },
  {
    name: "updateProspectCrmTeam",
    method: "put",
    url: CRUD_PROSPECT_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteProspectCrmTeam",
    method: "delete",
    url: CRUD_PROSPECT_CRM_TEAM,
    stateKey: "message",
  },

  // Customer CRM Team
  {
    name: "addCustomerCrmTeam",
    method: "post",
    url: CRUD_CUSTOMER_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getCustomerCrmTeam",
    method: "get",
    url: GET_CUSTOMER_CRM_TEAM_BY_CUSTOMER_ID,
    stateKey: "data",
  },
  {
    name: "updateCustomerCrmTeam",
    method: "put",
    url: CRUD_CUSTOMER_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteCustomerCrmTeam",
    method: "delete",
    url: CRUD_CUSTOMER_CRM_TEAM,
    stateKey: "message",
  },

  // Order CRM Team
  {
    name: "addOrderCrmTeam",
    method: "post",
    url: CRUD_ORDER_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "getOrderCrmTeam",
    method: "get",
    url: GET_ORDER_CRM_TEAM_BY_ORDER_ID,
    stateKey: "data",
  },
  {
    name: "updateOrderCrmTeam",
    method: "put",
    url: CRUD_ORDER_CRM_TEAM,
    stateKey: "message",
  },
  {
    name: "deleteOrderCrmTeam",
    method: "delete",
    url: CRUD_ORDER_CRM_TEAM,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "crmTeam",
  apiConfig,
  customReducers
);

const crmTeamSlice = slice;

export default crmTeamSlice.reducer;

// Export individual entity thunks
export const {
  // Contract
  addContractCrmTeam,
  getContractCrmTeam,
  updateContractCrmTeam,
  deleteContractCrmTeam,

  // Account
  addAccountCrmTeam,
  getAccountCrmTeam,
  updateAccountCrmTeam,
  deleteAccountCrmTeam,

  // Opportunity
  addOpportunityCrmTeam,
  getOpportunityCrmTeam,
  updateOpportunityCrmTeam,
  deleteOpportunityCrmTeam,

  // Contact
  addContactCrmTeam,
  getContactCrmTeam,
  updateContactCrmTeam,
  deleteContactCrmTeam,

  // Lead
  addLeadCrmTeam,
  getLeadCrmTeam,
  updateLeadCrmTeam,
  deleteLeadCrmTeam,

  // Campaign
  addCampaignCrmTeam,
  getCampaignCrmTeam,
  updateCampaignCrmTeam,
  deleteCampaignCrmTeam,

  // Inquiry
  addInquiryCrmTeam,
  getInquiryCrmTeam,
  updateInquiryCrmTeam,
  deleteInquiryCrmTeam,

  // Prospect
  addProspectCrmTeam,
  getProspectCrmTeam,
  updateProspectCrmTeam,
  deleteProspectCrmTeam,

  // Customer
  addCustomerCrmTeam,
  getCustomerCrmTeam,
  updateCustomerCrmTeam,
  deleteCustomerCrmTeam,

  // Order
  addOrderCrmTeam,
  getOrderCrmTeam,
  updateOrderCrmTeam,
  deleteOrderCrmTeam,
} = thunks;

export const { rowSelect: rowSelectCrmTeam } = actions;
